import React from 'react';
import { useParams } from 'react-router-dom';

import CompanyPage from 'pages/company/WorkspaceRoute/index';

export default function Standard() {
  const params = useParams();

  return <CompanyPage type="standard" match={{ params }} />;
}
